export default __webpack_public_path__ + "static/media/nested-item-standard.d4a1184c.png";